























































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import * as routes from "@/employer/route-names";
import { FundingOption } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component
export default class ContributionsNavigation extends Vue {
  routes = routes;
  activeTab = null;

  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();

  mounted (): void {
    this.activeTab = this.$route.name;
  }

  navigationClicked (pathName: string) {
    this.activeTab = pathName;
    this.$emit("navigation-tab-item-clicked", {
      name: this.$route.name,
      path: pathName
    });
  }

  get displayNextPayrollTab () {
    return this.isAwaitingActivation || this.isBendCalculatedPayroll;
  }

  get displayPayrollCalendarTab () {
    return this.isAwaitingActivation || this.isBendCalculatedPayroll;
  }

  get displayPayrollReportTab () {
    return (this.isAwaitingActivation || this.isBendCalculatedPayroll) && !this.displayCountributionsHistoryTab;
  }

  get displayCountributionsHistoryTab () {
    return this.showFundingMethod;
  }

  get displayUploadContributionsTab () {
    return this.fundingOption === FundingOption.ErCalculateBendPull;
  }

  get displayPendingContributionsTab () {
    return this.fundingOption === FundingOption.ErCalculateBendPull;
  }

  get displayContributionsTab () {
    return this.fundingOption === FundingOption.BendCalculatePull;
  }

  get displayAchContributionsTab () {
    return this.fundingOption !== FundingOption.ErCalculateErPush || this.displayCountributionsHistoryTab;
  }

  get isAwaitingActivation () {
    // since it's allgedely not possible to activate an employer without setting
    // their funding option, a value of none here means the admin didn't activate
    // their employer record yet, so they should still see all tabs
    return this.fundingOption === FundingOption.None;
  }

  get isBendCalculatedPayroll () {
    return this.fundingOption === FundingOption.BendCalculatePull;
  }

  get fundingOption (): FundingOption {
    if (this.userStore.currentEmployer && this.userStore.currentEmployer.fundingOption) {
      return this.userStore.currentEmployer.fundingOption;
    }

    return FundingOption.None;
  }

  get showFundingMethod () {
      return this.featureFlagStore.flags.showFundingMethod;
  }
}

